const Logo = ({ colorMode }) => {
  const styles = {
    path1: {
      light: '#0C1E3E',
      dark: '#EDF2F7',
    },
    path3: {
      light: '#fff',
      dark: '#0C1E3E',
    },
  }

  return (
    <svg
      height="100%"
      width="100%"
      fill="none"
      viewBox="0 0 186 248"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="93" cy="31" r="12" fill="#fff" />
      <path
        d="M162.75 31H124a30.998 30.998 0 0131 31H31a31 31 0 0131-31H23.25A23.25 23.25 0 000 54.25v170.5A23.25 23.25 0 0023.25 248h139.5A23.25 23.25 0 00186 224.75V54.25A23.251 23.251 0 00162.75 31zm-11.044 100.653l-69.265 68.685a5.825 5.825 0 01-6.354 1.227 5.805 5.805 0 01-1.88-1.276l-40.01-40.348a5.825 5.825 0 01-1.686-4.128 5.81 5.81 0 011.734-4.107l13.757-13.659a5.803 5.803 0 014.127-1.686 5.814 5.814 0 014.107 1.734l22.281 22.475 51.344-50.956a5.803 5.803 0 016.354-1.228 5.817 5.817 0 011.88 1.276l13.66 13.757a5.818 5.818 0 011.685 4.127 5.808 5.808 0 01-1.734 4.107z"
        fill={styles.path1[colorMode]}
      />
      <path
        d="M138.095 109.662a5.817 5.817 0 00-4.107-1.733 5.803 5.803 0 00-4.127 1.685L78.517 160.57l-22.281-22.475a5.82 5.82 0 00-4.107-1.734 5.826 5.826 0 00-4.127 1.686l-13.757 13.659a5.812 5.812 0 00-.048 8.235l40.01 40.348a5.805 5.805 0 004.106 1.734 5.825 5.825 0 004.128-1.685l69.265-68.685a5.808 5.808 0 001.303-6.339 5.818 5.818 0 00-1.254-1.895l-13.66-13.757zM124 31A30.999 30.999 0 0071.08 9.08 31 31 0 0062 31a31 31 0 00-31 31h124a30.999 30.999 0 00-31-31zM93 42.625A11.625 11.625 0 11104.625 31a11.59 11.59 0 01-3.396 8.229A11.605 11.605 0 0193 42.625z"
        fill="#2971FF"
      />
      <path
        d="M136.156 108.473a5.808 5.808 0 011.881 1.277l13.659 13.756a5.82 5.82 0 011.255 1.895 5.809 5.809 0 01-1.303 6.339l-69.266 68.685a5.826 5.826 0 01-6.354 1.227 5.804 5.804 0 01-1.88-1.276l-40.01-40.348a5.815 5.815 0 01.05-8.235l13.755-13.659a5.805 5.805 0 014.128-1.685 5.813 5.813 0 014.107 1.733l22.28 22.475 51.345-50.956a5.802 5.802 0 014.127-1.685c.765.004 1.522.16 2.226.457z"
        fill={styles.path3[colorMode]}
      />
    </svg>
  )
}

export default Logo
